import removeMarkdown from 'remove-markdown'

export function markdownToPlainText(md: string, maxLen?: number): string {
  const raw = String(md || '')

  let txt = removeMarkdown(raw, {
    gfm: true,
    stripListLeaders: true,
    useImgAltText: true,
    replaceLinksWithURL: true
  })

  // normalize white-spaces
  txt = txt.replace(/\r\n/g, '\n').replace(/\r/g, '\n')
  txt = txt.replace(/\n{2,}/g, ' · ').replace(/\n/g, ' ')
  txt = txt.replace(/[ \t]+/g, ' ').trim()

  if (typeof maxLen === 'number' && maxLen > 0 && txt.length > maxLen) {
    let cut = txt.slice(0, maxLen).trim()
    const i = cut.lastIndexOf(' ')
    if (i > 40) cut = cut.slice(0, i)
    txt = cut + '…'
  }

  return txt
}
